import React, { useState, useEffect } from "react";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import ShopHeader from "./ShopComponents/ShopHeader";
import CharacterSelect from "./ShopComponents/Radix";
import MainLink from "../Link";

const ucpGetShopItem = `${MainLink()}api/ucp/get-shop-item`;

// Компонент уведомления
const ToastMessage = ({ message, type, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, 3000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return <div className={`toast-message ${type}`}>{message}</div>;
};

function UCPShopBuyRender() {
    const [selectedCharacter, setSelectedCharacter] = useState(null);
    const [itemInfo, setItemInfo] = useState();
    const [item, setItem] = useState(null);
    const [toast, setToast] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        fetchItemInfo();
        fetchItemDetails();
    }, []);

    // Запрос на получение информации о товаре
    const fetchItemInfo = async () => {
        try {
            const item_id = new URL(window.location.href).searchParams.get("item_id");
            const response = await fetch(`${ucpGetShopItem}?item_id=${item_id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                },
            });

            if (!response.ok) throw new Error(`Ошибка загрузки предмета: ${response.status}`);
            setItemInfo(await response.json());
        } catch (error) {
            console.error("Ошибка загрузки данных:", error.message);
        }
    };

    // Запрос на получение характеристик товара
    const fetchItemDetails = async () => {
        try {
            const item_id = new URL(window.location.href).searchParams.get("item_id");
            const response = await fetch(`${MainLink()}api/ucp/get-shop-item-stats?item_id=${item_id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                },
            });

            if (!response.ok) throw new Error(`Ошибка загрузки данных: ${response.status}`);
            setItem(await response.json());
        } catch (error) {
            console.error("Ошибка загрузки данных:", error.message);
            setToast({ message: "Ошибка загрузки данных. Попробуйте позже.", type: "error" });
        }
    };

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handlePurchase = async () => {
        handleCloseModal();

        const userId = localStorage.getItem("user-id");
        if (!userId) {
            setToast({ message: "Ошибка: ID пользователя не найден.", type: "error" });
            return;
        }

        const CharId = selectedCharacter ? selectedCharacter.id : 0;
        const item_id = new URL(window.location.href).searchParams.get("item_id");

        const data = {
            user_id: userId,
            user_name: localStorage.getItem("user-login"),
            user_password: localStorage.getItem("user-password"),
            target_character: CharId,
            item_id
        };

        try {
            const response = await fetch(`${MainLink()}api/ucp/buy-item`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();
            switch (result) {
                case 1:
                    setToast({ message: "Успешная оплата!", type: "success" });
                    break;
                case -403:
                    setToast({ message: "Ошибка: Проверка пользователя не пройдена", type: "error" });
                    break;
                case -500:
                    setToast({ message: "Ошибка: Неверный пароль.", type: "error" });
                    break;
                case -1:
                    setToast({ message: "Ошибка: Недостаточно средств.", type: "error" });
                    break;
                case -2:
                    setToast({ message: "У вас уже есть премиум-аккаунт.", type: "error" });
                    break;
                case -3:
                    setToast({ message: "Превышен лимит транспорта.", type: "error" });
                    break;
                default:
                    setToast({ message: "Неизвестная ошибка. Попробуйте позже.", type: "error" });
                    break;
            }
        } catch (error) {
            console.error("Ошибка при покупке:", error);
            setToast({ message: "Ошибка при покупке. Проверьте подключение.", type: "error" });
        }
    };

    return (
        <div className="shop-container">
            <ShopHeader typeIndex={2} />

            <div className="ucp-two-blocks-container ucp-two-blocks-container-shop-buy">
                <div className="character-body shop-buy-body">
                    <img src={itemInfo ? "/media/" + itemInfo.imgUrl : "Загрузка"} alt=""/>
                    <span className="character-description shop-buy custom-shop-buy">
                        {itemInfo ? itemInfo.name : "Загрузка..."}
                    </span>
                </div>
                <SimpleBar className="simplebar-track-shop-buy" style={{ maxHeight: "550px", overflowY: "auto" }}>
                    <span className="ucp-title shop-title shop-buy person">ВЫБОР ПЕРСОНАЖА</span>

                    {itemInfo && itemInfo.type !== 1 && <CharacterSelect onSelect={setSelectedCharacter} />}

                    <span className="ucp-title shop-title shop-buy"
                          style={{ marginTop: "1%", marginBottom: "1%" }}>
                        ХАРАКТЕРИСТИКИ
                    </span>

                    <div className="ucp-simple-input-text ucp-simple-input-text-shop-buy">
                        <ul>
                            {item ? Object.entries(item).map(([key, value]) => (
                                <li key={key}>{value}</li>
                            )) : <li>Загрузка характеристик...</li>}
                        </ul>
                    </div>

                    <button className="ucp-simple-yellow-button main-purchase-button" onClick={handleOpenModal}>
                        КУПИТЬ
                    </button>
                </SimpleBar>
            </div>

            {toast && <ToastMessage message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

            {isModalOpen && (
                <div className="modal">
                    <div className="modal-content modal-content-buy">
                        <h2>Подтвердите покупку</h2>
                        <p>Вы уверены, что хотите купить {itemInfo?.name}?</p>
                        <div className="modal-buttons">
                            <button className="confirm-button" onClick={handlePurchase}>Подтвердить</button>
                            <button className="cancel-button" onClick={handleCloseModal}>Отмена</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export const ShopBuy = () => UCPShopBuyRender();
